import * as Yup from "yup";
import validationUtils from "./validationUtils";

const profileSchema = Yup.object().shape({
  first_name: validationUtils?.validateName("first_name"),

  last_name: validationUtils?.validateName("last_name"),

  email: validationUtils?.validateEmail(),

  phone_number: validationUtils?.validatePhoneNumber(),

  state: validationUtils?.validateRequiredAddress("state"),

  address: validationUtils?.validateRequiredAddress("address"),

  city: validationUtils?.validateRequiredAddress("city"),

  zipcode: validationUtils?.validateRequiredAddress("zipcode"),

  patient_id: validationUtils?.validateUnrequiredPatientField("patient_id"),

  medical_recommendation: validationUtils?.validateUnrequiredPatientField(
    "medical_recommendation"
  ),
});

export default profileSchema;
